import { Component, OnInit } from '@angular/core';
import {IBreadcrumb} from "../../../eca-breadcrumb/models/breadcrumb.interface";
import {EcaBreadcrumbService} from "../../../eca-breadcrumb/services/eca-breadcrumb.service";

@Component({
  selector: 'app-order-form-page',
  templateUrl: './order-form-page.component.html',
  styleUrls: ['./order-form-page.component.scss']
})
export class OrderFormPageComponent implements OnInit {

  constructor(private ecaBreadcrumbService: EcaBreadcrumbService) { }

  ngOnInit(): void {
    this.populateBreadcrumbs();
  }

  private populateBreadcrumbs() {
    const breadCrumbs = new Array<IBreadcrumb>();
    this.ecaBreadcrumbService.breadCrumbs.next(breadCrumbs);
    breadCrumbs.push({label: 'Order Form', iconName: 'file-contract', routeLink: '/order-form'} as IBreadcrumb);
    breadCrumbs.push({label: 'HideDashboard'} as IBreadcrumb);
    this.ecaBreadcrumbService.breadCrumbs.next(breadCrumbs);
  }

}
